import script from "./ManageableSelectField.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageableSelectField.vue?vue&type=script&setup=true&lang=js"

import "./ManageableSelectField.vue?vue&type=style&index=0&id=9436c5de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9436c5de"]])

export default __exports__